<script setup lang="ts">
  import type { ProductVariantResource, ProductFlexibleResource } from '@storefront/resources';
  import { ref } from 'vue';
  import ShopProductViewConfiguratorItems from './ShopProductViewConfiguratorItems.vue';
  import ShopProductViewConfiguratorSummary from './ShopProductViewConfiguratorSummary.vue';

  interface Props {
    product: ProductFlexibleResource,
    variant: ProductVariantResource,
  }

  const props = defineProps<Props>();
  const required = ref(0);

  const initial = ref({
    product: props.product.id,
    variant: props.variant.id,
    items: [],
    extras: props.product.flexibleExtras.map((extra) => {
      return {
        extraId: extra.id,
        productId: extra.products[0]?.productId,
        variantId: extra.products[0]?.variantId,
        isDropShipping: extra.isDropShipping,
        isMedicinalProduct: extra.isMedicinalProduct,
        stockAvailable: extra.products[0]?.stockAvailable,
        stockOnOrder: extra.products[0]?.stockOnOrder,
        quantity: extra.quantity * (extra.products[0]?.stockUnitBase || 1),
      };
    }),
  });
</script>
<template>
  <FormController :action="$route('web.cart.sets.store')" method="POST" :data="initial" v-slot="{ processing, submit }">
    <ShopProductViewConfiguratorItems :product="product" v-model:required="required" />
    <ShopProductViewConfiguratorExtras :product="product" :disabled="required > 0" />
    <ShopProductViewConfiguratorSummary :product="product" :variant="variant" :required="required" :processing="processing" :submit="submit" />
  </FormController>
</template>
